import React, { useCallback, useMemo } from 'react';

import { Filter } from '@pkg/classes';
import { type Collection } from '@pkg/graphql/codegen/graphql';

import { useNFTsFiltersStore } from '@app/store/zustand';

import { AssetCount, ContentGroup, Name, NameGroup, Thumbnail, Wrapper } from './styles';

interface Props {
    collectionData: Collection;
}

export const CollectionFilterEntry = ({ collectionData }: Props) => {
    const { currentFilters, setCurrentFilters } = useNFTsFiltersStore();
    const { id, imageUrl, name, marketData } = collectionData;
    const totalSupply = marketData?.totalSupply;
    const currentFilterValues = currentFilters.get('collections');
    const selected = useMemo(() => !!currentFilterValues?.includes(id), [currentFilterValues, id]);

    const handleClick = useCallback(() => {
        const filtersClone = new Filter(currentFilters);
        if (selected) {
            filtersClone.remove('collections', id);
        } else {
            filtersClone.append('collections', id);
        }

        setCurrentFilters(filtersClone);
    }, [currentFilters, id, selected, setCurrentFilters]);

    return (
        <Wrapper $selected={selected} onClick={() => handleClick()}>
            <ContentGroup>
                <Thumbnail $image={imageUrl} />
                <NameGroup>
                    <Name>{name}</Name>
                </NameGroup>
            </ContentGroup>

            {totalSupply ? (
                <AssetCount>
                    {totalSupply} <span>Assets</span>
                </AssetCount>
            ) : null}
        </Wrapper>
    );
};
